module.exports = __webpack_public_path__ + "media/flags/gg-2cc5f518.svg";